/**
 * @fileoverview gRPC-Web generated client stub for mazey.insti
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.mazey = {};
proto.mazey.insti = require('./insti_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.mazey.insti.InstiServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.mazey.insti.InstiServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mazey.insti.GetInstiListRequest,
 *   !proto.mazey.insti.GetInstiListResponse>}
 */
const methodDescriptor_InstiService_GetInstiList = new grpc.web.MethodDescriptor(
  '/mazey.insti.InstiService/GetInstiList',
  grpc.web.MethodType.UNARY,
  proto.mazey.insti.GetInstiListRequest,
  proto.mazey.insti.GetInstiListResponse,
  /**
   * @param {!proto.mazey.insti.GetInstiListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mazey.insti.GetInstiListResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.mazey.insti.GetInstiListRequest,
 *   !proto.mazey.insti.GetInstiListResponse>}
 */
const methodInfo_InstiService_GetInstiList = new grpc.web.AbstractClientBase.MethodInfo(
  proto.mazey.insti.GetInstiListResponse,
  /**
   * @param {!proto.mazey.insti.GetInstiListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mazey.insti.GetInstiListResponse.deserializeBinary
);


/**
 * @param {!proto.mazey.insti.GetInstiListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.mazey.insti.GetInstiListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mazey.insti.GetInstiListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mazey.insti.InstiServiceClient.prototype.getInstiList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mazey.insti.InstiService/GetInstiList',
      request,
      metadata || {},
      methodDescriptor_InstiService_GetInstiList,
      callback);
};


/**
 * @param {!proto.mazey.insti.GetInstiListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mazey.insti.GetInstiListResponse>}
 *     Promise that resolves to the response
 */
proto.mazey.insti.InstiServicePromiseClient.prototype.getInstiList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mazey.insti.InstiService/GetInstiList',
      request,
      metadata || {},
      methodDescriptor_InstiService_GetInstiList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mazey.insti.GeneralRequest,
 *   !proto.mazey.insti.GetInstiBasicInfoResponse>}
 */
const methodDescriptor_InstiService_GetInstiBasicInfo = new grpc.web.MethodDescriptor(
  '/mazey.insti.InstiService/GetInstiBasicInfo',
  grpc.web.MethodType.UNARY,
  proto.mazey.insti.GeneralRequest,
  proto.mazey.insti.GetInstiBasicInfoResponse,
  /**
   * @param {!proto.mazey.insti.GeneralRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mazey.insti.GetInstiBasicInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.mazey.insti.GeneralRequest,
 *   !proto.mazey.insti.GetInstiBasicInfoResponse>}
 */
const methodInfo_InstiService_GetInstiBasicInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.mazey.insti.GetInstiBasicInfoResponse,
  /**
   * @param {!proto.mazey.insti.GeneralRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mazey.insti.GetInstiBasicInfoResponse.deserializeBinary
);


/**
 * @param {!proto.mazey.insti.GeneralRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.mazey.insti.GetInstiBasicInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mazey.insti.GetInstiBasicInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mazey.insti.InstiServiceClient.prototype.getInstiBasicInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mazey.insti.InstiService/GetInstiBasicInfo',
      request,
      metadata || {},
      methodDescriptor_InstiService_GetInstiBasicInfo,
      callback);
};


/**
 * @param {!proto.mazey.insti.GeneralRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mazey.insti.GetInstiBasicInfoResponse>}
 *     Promise that resolves to the response
 */
proto.mazey.insti.InstiServicePromiseClient.prototype.getInstiBasicInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mazey.insti.InstiService/GetInstiBasicInfo',
      request,
      metadata || {},
      methodDescriptor_InstiService_GetInstiBasicInfo);
};


module.exports = proto.mazey.insti;

